import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

export const VaMedicalRecordsIntroDescription = () => (
  <>
    <p>
      On the following screens, we’ll ask you about the VA or military
      healthcare providers that treated your conditions.
    </p>
    <h4>Records we can review from VA or military healthcare providers</h4>
    <p>
      We can locate, access, and review records from these healthcare providers:
    </p>
    <ul>
      <li>VA medical centers or clinics</li>
      <li>TRICARE healthcare program</li>
      <li>Community-Based Outpatient Clinics</li>
      <li>DOD military treatment facilities</li>
    </ul>
  </>
);

export default {
  uiSchema: {
    ...titleUI(
      'Request medical records from VA or military healthcare providers',
      VaMedicalRecordsIntroDescription,
    ),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
